<template>
  <div class="container">
    <h2 class="title">聯絡我們</h2>
    <form class="form" @submit.prevent="handleRegister">
      <!-- 姓名 -->
      <div class="form-group">
        <label for="name" class="required-label">姓名</label>
        <input
          type="text"
          id="name"
          v-model="formData.name"
          placeholder="請輸入姓名"
          required
        />
      </div>

      <!-- 電子郵件 -->
      <div class="form-group">
        <label for="email" class="required-label">電子郵件</label>
        <input
          type="email"
          id="email"
          v-model="formData.email"
          placeholder="請輸入電子郵件"
          required
        />
      </div>

      <!-- 手機 -->
      <div class="form-group">
        <label for="phone" class="required-label">手機</label>
        <input
          type="tel"
          id="phone"
          v-model="formData.phone"
          placeholder="請輸入手機號碼"
          required
        />
      </div>

      <!-- 您的留言 -->
      <div class="form-group">
        <label for="message" class="required-label">您的留言</label>
        <textarea
          id="message"
          v-model="formData.message"
          placeholder="您的留言"
          required
          rows="5"
        ></textarea>
      </div>

      <!-- 送出按鈕 -->
      <button type="submit" class="btn-submit">送出</button>
    </form>
  </div>
</template>

<script>
import ContactusPage from "@/assets/js/ContactusPage.js";

export default {
  name: "ContactusPage",
  mixins: [ContactusPage], // 混入邏輯
};
</script>

<style src="@/assets/css/contactus.css" scoped></style>
